import { Container } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { FilterPageProps, ListProps, TabPageProps } from "@saleor/types";
import React from "react";
import { useIntl } from "react-intl";

import { GrabExpressUrlQueryParams } from "../../url";
import GrabExpressList from "../GrabExpressList";
import {
  createFilterStructure,
  GrabExpressFilterKeys,
  GrabExpressListFilterOpts
} from "./filters";

interface GrabExpressListPageProp
  extends ListProps,
    FilterPageProps<GrabExpressFilterKeys, GrabExpressListFilterOpts>,
    TabPageProps {
  params: GrabExpressUrlQueryParams;
  orders: any;
  tabs: any;
}

const GrabExpressListPage: React.FC<GrabExpressListPageProp> = ({
  currencySymbol,
  currentTab,
  filterOpts,
  initialSearch,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  orders,
  tabs,
  params,
  download,
  ...listProps
}) => {
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts);

  return (
    <>
      <Container>
        <PageHeader title="Grab Express">
          <Button
            color="primary"
            variant="contained"
            disabled={!orders}
            onClick={download}
          >
            Download
          </Button>
        </PageHeader>

        <Card>
          <FilterBar
            allTabLabel={intl.formatMessage({
              defaultMessage: "All",
              description: "tab name"
            })}
            currencySymbol={currencySymbol}
            currentTab={currentTab}
            tabs={tabs}
            filterStructure={structure}
            searchPlaceholder={intl.formatMessage({
              defaultMessage: "Search Payout"
            })}
            initialSearch={initialSearch}
            onSearchChange={onSearchChange}
            onFilterChange={onFilterChange}
            onAll={onAll}
            onTabChange={onTabChange}
            onTabDelete={onTabDelete}
            onTabSave={onTabSave}
          />
          <GrabExpressList orders={orders} {...listProps} />
        </Card>
      </Container>
    </>
  );
};

export default GrabExpressListPage;
